export default {
  page: {
    dashboard: {
      title: 'Dashboard',
      analysis: 'Analysis',
      monitor: 'Monitor',
      workspace: 'Work Space',
    },
    form: {
      title: 'Form',
      basicForm: 'Basic Form',
      formLayout: 'Form Layout',
      advancedForm: 'Advanced Form',
      dynamicForm: 'Dynamic Form'
    },
    list: {
      title: 'List',
      basicList: 'Basic List',
      cardList: 'Card List',
      editableList: 'Editable List',
      advanceList: 'Advance List',
      treeList: 'Tree List',
    },
    abnormal: {
      title: 'Abnormal',
    },
    user: {
      title: 'User',
      center: 'User Center',
      settings: 'User Settings',
    },
  },
};
